import React, { createContext, useContext, } from "react";
import { enChatStrings, deChatStrings } from "../strings";
const TranslationContext = createContext(enChatStrings);
export function TranslationProvider({ translations, children, }) {
    var _a;
    let locale = "";
    if (typeof window !== "undefined") {
        locale = (_a = sessionStorage.getItem("locale")) !== null && _a !== void 0 ? _a : "";
    }
    const chatStrings = locale === "de" ? deChatStrings : enChatStrings;
    return (React.createElement(TranslationContext.Provider, { value: translations !== null && translations !== void 0 ? translations : chatStrings }, children));
}
export default function useTranslation() {
    const translation = useContext(TranslationContext);
    if (!translation) {
        throw Error("useTranslation: `translation` is undefined. Seems you forgot to wrap your form in `<TranslationProvider />`");
    }
    return translation;
}
//# sourceMappingURL=useTranslation.js.map